/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Endpoint_Returns_NoteInputs */

const en_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The response is normalized JSON with the same envelope every AnyAPI endpoint returns, so parsing a second endpoint is a change of URL and nothing else.`)
};

const zh_hans1_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应是统一格式的 JSON，外层结构与每个 AnyAPI 接口相同，所以解析另一个接口只需换一个 URL，别的都不用改。`)
};

const pt_br2_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A resposta é JSON normalizado, com o mesmo envelope que todo endpoint da AnyAPI retorna, então processar um segundo endpoint é só trocar a URL, e nada mais.`)
};

const es_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respuesta es JSON normalizado con el mismo envoltorio que devuelve cada endpoint de AnyAPI, así que procesar un segundo endpoint es solo cambiar la URL.`)
};

const fr_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La réponse est du JSON normalisé avec la même enveloppe que celle de tous les endpoints AnyAPI, donc analyser un second endpoint revient à changer l’URL et rien d’autre.`)
};

const de_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Antwort ist normalisiertes JSON mit demselben Envelope, den jeder AnyAPI-Endpoint liefert, sodass das Parsen eines zweiten Endpoints nur eine geänderte URL bedeutet.`)
};

const ru_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответ это нормализованный JSON с тем же конвертом, что возвращает каждый эндпоинт AnyAPI, поэтому разбор второго эндпоинта это смена URL и ничего больше.`)
};

const it_seo_endpoint_returns_note = /** @type {(inputs: Seo_Endpoint_Returns_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La risposta è JSON normalizzato con la stessa busta che restituisce ogni endpoint AnyAPI, quindi analizzare un secondo endpoint significa cambiare l'URL e nient'altro.`)
};

/**
* | output |
* | --- |
* | "The response is normalized JSON with the same envelope every AnyAPI endpoint returns, so parsing a second endpoint is a change of URL and nothing else." |
*
* @param {Seo_Endpoint_Returns_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_returns_note = /** @type {((inputs?: Seo_Endpoint_Returns_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Returns_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_returns_note(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_returns_note(inputs)
	if (locale === "es") return es_seo_endpoint_returns_note(inputs)
	if (locale === "fr") return fr_seo_endpoint_returns_note(inputs)
	if (locale === "de") return de_seo_endpoint_returns_note(inputs)
	if (locale === "ru") return ru_seo_endpoint_returns_note(inputs)
	if (locale === "it") return it_seo_endpoint_returns_note(inputs)
	return en_seo_endpoint_returns_note(inputs)
});